import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CartecreditformPage } from './cartecreditform.page';

const routes: Routes = [
  {
    path: '',
    component: CartecreditformPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CartecreditformPageRoutingModule {}
